import React from 'react';

const Icon = ({ size = 17, children }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {children}
    </svg>
);

export const SelectIcon = () => <Icon><path d="M5 3l6 16 2-6 6-2z" /></Icon>;
export const PenIcon = () => <Icon><path d="M4 20l1-4L16 5l3 3L8 19l-4 1z" /></Icon>;
export const TextIcon = () => <Icon><path d="M5 6h14M12 6v13M9 19h6" /></Icon>;
export const ShapesIcon = () => (
    <Icon><rect x="3" y="10" width="8" height="8" rx="1" /><circle cx="16.5" cy="14" r="4" /><path d="M10 3l4 7H6z" /></Icon>
);
export const EraserIcon = () => (
    <Icon><rect x="3" y="14" width="10" height="6" rx="1.5" transform="rotate(-20 8 17)" /><path d="M12 12l6-6 4 4-6 6" /></Icon>
);
export const UploadIcon = () => (
    <Icon><path d="M12 15V4M8 8l4-4 4 4" /><path d="M4 15v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4" /></Icon>
);
export const UndoIcon = () => (
    <Icon><path d="M9 14 4 9l5-5" /><path d="M4 9h10.5A5.5 5.5 0 0 1 20 14.5V15" /></Icon>
);
export const RedoIcon = () => (
    <Icon><path d="M15 14l5-5-5-5" /><path d="M20 9H9.5A5.5 5.5 0 0 0 4 14.5V15" /></Icon>
);
// Full-bleed glyphs: a touch smaller so they weigh the same as the tool icons.
export const PlusIcon = () => <Icon size={15}><path d="M12 5v14M5 12h14" /></Icon>;
export const MinusIcon = () => <Icon size={15}><path d="M5 12h14" /></Icon>;
export const FitIcon = () => (
    <Icon size={15}><path d="M9 4H5a1 1 0 0 0-1 1v4M15 4h4a1 1 0 0 1 1 1v4M9 20H5a1 1 0 0 1-1-1v-4M15 20h4a1 1 0 0 0 1-1v-4" /></Icon>
);
export const CloseIcon = () => <Icon size={15}><path d="M6 6l12 12M18 6L6 18" /></Icon>;
